import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const FAQS = [{
  q: '¿Para qué edad es el método?',
  a: 'El método está diseñado para bebés de 4 a 24 meses. Para cada rango de edad hay tablas, protocolos y adaptaciones específicas.'
}, {
  q: "¿Es un método de 'dejar llorar'?",
  a: 'No. El método trabaja siempre con presencia parental. No te pide que te vayas y no vuelvas hasta la mañana. Te pide que respondas de forma gradual y mínimamente efectiva, siempre con presencia.'
}, {
  q: '¿En cuánto tiempo veo resultados?',
  a: 'La mayoría de las familias empieza a ver cambios en algún área entre el día 3 y el día 7. Los resultados completos dependen de la consistencia y de la situación de partida de cada bebé.'
}, {
  q: '¿Funciona si estoy sola sin pareja?',
  a: 'Sí. El método está diseñado para funcionar con uno o dos cuidadores. Si hay dos cuidadores, el capítulo de alineación entre cuidadores es especialmente útil.'
}, {
  q: '¿Qué pasa si mi bebé se enferma en el medio del proceso?',
  a: 'El PDF Extra 1 de la Edición Completa cubre exactamente eso. En el pack base, el Tomo 6 incluye pautas básicas para pausar y retomar.'
}, {
  q: '¿Cómo recibo el producto?',
  a: 'Inmediatamente después del pago recibís un email con el enlace de descarga. El formato es PDF, compatible con cualquier dispositivo.'
}, {
  q: '¿Y si ya probé otros métodos y no funcionaron?',
  a: 'Eso es exactamente para quién está diseñado este método. Para las familias que ya probaron cosas sueltas sin un sistema claro. La diferencia es que acá tenés el sistema completo, no técnicas aisladas.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-soft-gray py-20 px-4" data-id="element-81">
      <div className="max-w-3xl mx-auto" data-id="element-82">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-3xl md:text-4xl font-bold text-navy text-center mb-12" data-id="element-83">
          Preguntas frecuentes
        </motion.h2>

        <div className="space-y-4" data-id="element-84">
          {FAQS.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden" data-id="element-85">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none" data-id="element-86">
                <span className="font-semibold text-navy text-lg pr-4" data-id="element-87">
                  {faq.q}
                </span>
                <ChevronDown className={`text-sky transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} size={20} data-id="element-88" />
              </button>
              <AnimatePresence data-id="element-89">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-90">
                    <div className="px-6 pb-4 text-navy/70 leading-relaxed" data-id="element-91">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}